import { hoyEnChile } from './dateHelpers';
import { parseDateOnly } from './formatters';

export type TipoMiembro = 'adulto' | 'niño';

// A partir de los 18 años cumplidos, el miembro es adulto.
const EDAD_ADULTO = 18;

export function calcularEdad(fechaNacimiento: string | null | undefined): number | null {
  if (!fechaNacimiento) return null;
  const nacimiento = parseDateOnly(fechaNacimiento);
  if (Number.isNaN(nacimiento.getTime())) return null;
  // "Hoy" es el día civil de Chile, no el del navegador
  const hoy = parseDateOnly(hoyEnChile());
  const cumplioEsteAnio =
    hoy.getMonth() > nacimiento.getMonth() ||
    (hoy.getMonth() === nacimiento.getMonth() && hoy.getDate() >= nacimiento.getDate());
  const edad = hoy.getFullYear() - nacimiento.getFullYear() - (cumplioEsteAnio ? 0 : 1);
  return edad >= 0 ? edad : null;
}

// Tipo de miembro derivado de la fecha de nacimiento. Null si no hay fecha válida.
export function tipoMiembroPorEdad(fechaNacimiento: string | null | undefined): TipoMiembro | null {
  const edad = calcularEdad(fechaNacimiento);
  if (edad === null) return null;
  return edad >= EDAD_ADULTO ? 'adulto' : 'niño';
}
